export function detectNewFire(
  ownPlayer: { lastFiredAt: number } | undefined,
  prevLastFiredAt: number,
): boolean {
  return ownPlayer !== undefined && ownPlayer.lastFiredAt !== prevLastFiredAt;
}
